module.exports = __webpack_public_path__ + "img/151-united-arab-emirates.98281a5e.svg";